var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('group-header',{attrs:{"grpid":_vm.groupId}}),_c('chat-comp'),_c('chat-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }